import { render, staticRenderFns } from "./ImDialogConfirmation.vue?vue&type=template&id=6d75b4d7&"
import script from "./ImDialogConfirmation.vue?vue&type=script&lang=js&"
export * from "./ImDialogConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports